import React, { useState } from "react";
import { Link } from "react-router-dom";
import meetingPlusWhiteLogoForDashBoard from "../../../assets/images/minutes-vault-white-logo.png";
import meeting2Logo from "../../../assets/images/meeting2.svg";
import actionLogo from "../../../assets/images/registration.png";
import leadLogo from "../../../assets/images/lead-icon.png";
import subscriptionLogo from "../../../assets/images/subscription.png";
import emailLogLogo from "../../../assets/images/email-log.png";
import email from "../../../assets/images/mail.png"
import "./AdminSidebar.css";
import { useSelector, useDispatch } from "react-redux";
import { closeSidebar } from "../../../redux/actions/commonActions/commonAction";

function AdminSidebar() {
  const dispatch = useDispatch();
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  const commonData = useSelector((state) => state.common);
  return (
    <div className={commonData?.sidebarStatus ? "sidebar-open-now" : ""}>
      <div className="sidebar">
        <div className="sidebar-close" onClick={() => dispatch(closeSidebar())}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="#ffff"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
          </svg>
        </div>

        <div className="mt-4 top-logo">
          <Link to="/leads">
            <div className="ntspl-logo">
              <img src={meetingPlusWhiteLogoForDashBoard} alt="Logo" />
            </div>
          </Link>
        </div>

        <ul className="sidebar-content">
          <Link to="/leads" className="link">
            <li className={currentPath === "/leads" ? "active-menu" : ""}>
              <img className="icon" src={leadLogo} alt="Dashboard" />
              Leads
            </li>
          </Link>

          <Link to="/registration" className="link">
            <li className={currentPath === "/registration" ? "active-menu" : ""}>
              <img className="icon" src={actionLogo} alt="Registrations" />
              Registrations
            </li>
          </Link>

          {/* <Link to="/subscription" className="link">
            <li className={currentPath === "/subscription" ? "active-menu" : ""}>
              <img className="icon" src={subscriptionLogo} alt="Payment History" />
              Subscriptions
            </li>
          </Link> */}

          <Link to="/admin-emaillogs" className="link">
            <li className={currentPath === "/admin-emaillogs" ? "active-menu" : ""}>
              <img className="icon" src={emailLogLogo} alt="Email Logs" />
              Email Logs
            </li>
          </Link> 
          
          <Link to="/admin-emailtemplate" className="link">
            <li className={currentPath === "/admin-emailtemplate" ? "active-menu" : ""}>
              <img className="icon" src={email} alt="Email Logs" />
              Email Template
            </li>
          </Link>
        </ul>

        <img className="meeting-img" src={meeting2Logo} alt="Sidebar Illustration" />
      </div>
    </div>
  );
};


export default AdminSidebar